import Icon from 'components/Varios/Icons';
import { Rutas_Datos_Personales, useSideBarContext } from 'Context/SideBarContext';
import React, { useState } from 'react'
import {  useHistory, useLocation } from 'react-router-dom';
import { TransitionStatus } from 'react-transition-group';

import Administrador from "Context/SideBarContext";




//Iconos barra de navegacion 

import {ReactComponent as IconoOpcionUsuario} from "assets/icons/Sidebar_Nuevo_Opciones/usuario(B).svg"
import { Icono_Flecha_Regreso, UserData } from './Sidebar_Principal';
import { function_renderizado_segun_rol_usuarios } from './Sidebar_Principal_Content';

export interface Sidebar_Principal_Datos_PersonalesProps {
    state_transition: TransitionStatus,
    datos_usuario: UserData

}




const Sidebar_Principal_Datos_Personales = (props: Sidebar_Principal_Datos_PersonalesProps) => {
    const CLASE_OPCIONES_SELECCIONADAS: string = "selectedOpcionRutasDatosPersonales";
    const CLASE_OPCIONES: string = "nombresRutasDatosPersonales";
    const { valoressubMenu, setsubMenu, titulo_opcion_padre,subMenuDatosPersonales, setsubMenuDatosPersonales, routes_datos_personales, valoresMenuPrincipal,setsubMenuNieto } = useSideBarContext()
    const [state_clase, setstate_clase] = useState<string>(CLASE_OPCIONES)

    const { roles, roles_usuario } = props.datos_usuario


    let history = useHistory();
    let location = useLocation();







    const component_arrow_left_header = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
    </svg>

    const function_seleccionar_clase_opciones = (ruta: string): boolean => {
        var match: boolean = location.pathname === ruta
        return match;

    }



    const function_renderizado_segun_rolesDeRutas = (rutas: Rutas_Datos_Personales, index: number, roles_datos_personales: Array<string>) => {


        const opcion_barra_datos_personales = <div className={state_clase} 
        onClick={() => { 
            history.push(`/admin${rutas.path}`);
        }} 
        key={index + "RUTAS_DATOS_PERSONALES"}>
            <div>
                {<Icon className="" kind={rutas.icon} fill={`#243165`} width={32} height={32} style={{ marginRight: 12 }} />}
            </div>
            <div className="">
                {rutas.name}
            </div>

        </div>


        if (rutas.rol) {

            var indice_respuesta:number = rutas.rol.findIndex((value)=>{
                return value == roles_datos_personales[0];
            });

            if(indice_respuesta != -1) {
                return opcion_barra_datos_personales
            }
        }
        else {
            return opcion_barra_datos_personales
        }



    }

    const function_choice_animation_style = () => {

        const componente_salio = props.state_transition === "exited" || props.state_transition === "unmounted" || props.state_transition ==="exiting"
        const timing = ".3s"

        if(props.state_transition === "entering" && subMenuDatosPersonales) {
            return {
                animation:`moveSubContainer ${timing} forwards`
            }
        }
        
        else if(props.state_transition === "entered"){
            return {
                transform:"translateX(0px)"
            }
        }
        else if(componente_salio && !subMenuDatosPersonales){
            return{
                animation:`moveSubContainer ${timing} reverse forwards`
            }
        }
        
    }


    return (
        <div className={"sidenavPrincipalDP"} style={function_choice_animation_style()}>
            
            
            <div className="text-center iconosMenuDatosPersonales">
                {/* {valoresMenuPrincipal && valoresMenuPrincipal.map((opciones, index) => {
                    if(index <= 2){
                        return function_renderizado_segun_rol_usuarios(opciones, index,roles_usuario,'ICONO')
                    }
                })} */}
            </div>


            <div className="submenuHeaderDP" onClick={() => { setsubMenuDatosPersonales(false)}}>
                <div className="arrow_UsuarioDP">
                    {Icono_Flecha_Regreso}
                </div>
                {/* <div className="containerIconoUsuarioDP">
                    <IconoOpcionUsuario id="iconoUsuarioDP" className="iconoUsuarioDP"/>
                </div> */}
                <div className="nombreUsuarioDP">
                    {"DATOS PERSONALES"}

                </div>
            </div>

            <div className="texto_sidebar_datos_personales text-center mt-4 mb-3">
                <span id="bold_datos_personales">Datos personales/</span>
                <span>Actualización</span>
            </div>
            {routes_datos_personales.map((rutas, index) => {
                return function_renderizado_segun_rolesDeRutas(rutas,index,roles)
            })}
        </div>
    )
}
export default Sidebar_Principal_Datos_Personales;
